import { Header } from '../../../feature/header/component/original/organism/Header'
import { ChildrenProps } from '../../../model/React'
import { AppBox } from '../../common/analog/molecule/AppBox'
import { NodeId } from '../../../util/node-id'
import { CssUnit } from '../../../feature/theme/model/CssUnit'
import { useScrollSizes } from '../../../hook/sizes/useScrollSizes'
import { SxHelperStyle } from '../../../feature/theme/style/styleUtilities'
import { AppContainer } from '../../common/analog/molecule/AppContainer'
import { Box, GlobalStyles, Theme, useMediaQuery } from '@mui/material'
import { useAuthStore } from 'src/feature/auth/store/auth.store'
import { WithDrawerlayout } from './WithDrawerLayout'
import { useState } from 'react'

const DEFAULT_DRAWER_WIDTH = 250
const CLOSED_DRAWER_WIDTH = 70

export function BaseLayout(props: ChildrenProps) {
  const { isAuthorized } = useAuthStore()
  const header = useScrollSizes(NodeId.HEADER)
  const isSmallScreen = useMediaQuery('(max-width:900px)')

  const [isDrawerOpen, setDrawerOpen] = useState(true)
  const dynamicDrawerWidth = isDrawerOpen ? DEFAULT_DRAWER_WIDTH : CLOSED_DRAWER_WIDTH

  const contentHeight = isAuthorized
    ? `calc(100vh - ${header?.scroll.height ?? 80}px)`
    : '100vh'
  const scrollMarginTop = header?.scroll.height ? `${header.scroll.height + 10}px` : '5rem'
  
  return (
    <>
      <GlobalStyles styles={styles.global} />
      <AppBox sx={styles.root}>
        {!isSmallScreen && isAuthorized && (
          <WithDrawerlayout
            drawerWidth={dynamicDrawerWidth}
            isOpen={isDrawerOpen}
          />
        )}
        <Box sx={styles.mainArea}>
          {isAuthorized && (
            <Header
              isDrawerOpen={isDrawerOpen}
              onToggleDrawer={() => setDrawerOpen(prev => !prev)}
            />
          )}
          <AppContainer
            id={NodeId.CONTENT}
            sx={styles.content(contentHeight, scrollMarginTop)}
          >
            {props.children}
          </AppContainer>
        </Box>
      </AppBox>
    </>
  )
}

const styles = {
  global: {
    html: {
      height: '100%',
      overflow: 'hidden',
    },
    body: {
      height: '100%',
      overflow: 'hidden',
    },
    '#root': {
      height: '100%',
      overflow: 'hidden',
    },
  },
  root: {
    display: 'flex',
    position: 'relative',
    height: '100vh',
    overflow: 'hidden',
  },
  mainArea: {
    ...SxHelperStyle.flexColumn,
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
  },
  content: (height: CssUnit, scrollMarginTop: CssUnit) => ({ breakpoints }: Theme) => ({
    width: '100%',
    flexGrow: 1,
    height,
    minHeight: 0,
    scrollMarginTop,
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    [breakpoints.up('xs')]: {
      padding: 0,
    },
    maxWidth: 'unset',
  }),
}
